import { CrudModel } from "./_crud";
import { crudGet, crudRead } from "./_request";

export class tagModel extends CrudModel {
	constructor() {
		super("admin/tag", [], []);
	}

	override async read(id: string) {
		const queryParameters = {
			join: await this.getJoinableFields(),
		};

		return crudRead(this.endpoint, id, queryParameters);
	}

	async search({ page, limit, searchParam, search }: any) {
		const queryParams: any = { page, limit, searchParam };

		if (search && search.classification) {
			queryParams.classifications = search.classification;
		}

		return crudGet(this.endpoint, "", queryParams);
	}
}

export default new tagModel();
